// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostItem_wrapper__--lB5","image":"PostItem_image__2FN71","content":"PostItem_content__10o_c","date":"PostItem_date__1SL6i","title":"PostItem_title__R6FIm"};